import { render, staticRenderFns } from "./CopyBtn.vue?vue&type=template&id=e52ecf0a"
import script from "./CopyBtn.vue?vue&type=script&lang=js"
export * from "./CopyBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports